// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Activity } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconActivity(props: any) {
    return <IconBase icon={Activity} {...props} />
  }

  export default IconActivity
  